import { createSelector } from 'reselect';

const selectPriceBooks = (state: any) => state.priceBooks;


export const selectPriceBookCurrentItem = createSelector([selectPriceBooks], (priceBooks) => priceBooks.current);

export const selectPriceBooksListItems = createSelector([selectPriceBooks], (priceBooks) => priceBooks.list);

export const selectPriceBookItemById = (itemId: any) =>
    createSelector(selectPriceBooksListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPriceBookQueryItems = createSelector([selectPriceBooks], (priceBooks) => priceBooks.query);

export const selectPriceBookCreatedItem = createSelector([selectPriceBooks], (priceBooks) => priceBooks.create);

export const selectPriceBookUpdatedItem = createSelector([selectPriceBooks], (priceBooks) => priceBooks.update);

export const selectPriceBookReadItem = createSelector([selectPriceBooks], (priceBooks) => priceBooks.read);

export const selectPriceBookDeletedItem = createSelector([selectPriceBooks], (priceBooks) => priceBooks.delete);

export const selectPriceBookSearchedItems = createSelector([selectPriceBooks], (priceBooks) => priceBooks.search);

export const selectPriceBookItemsCount = createSelector([selectPriceBooks], (priceBooks) => priceBooks.count);

export const selectPriceBookItemsFilter = createSelector([selectPriceBooks], (priceBooks) => priceBooks.filter);